import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../fulfillment-planner/labeled-row/messages';
import LabeledRow from '../../../fulfillment-planner/labeled-row';

import style from './style.module.less';

const Package = ({ packageType = '', showMdash = false }) => {
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.package} />} labelClassName={style.label}>
      {showMdash && <span className={style.mdash}>&mdash;</span>}
      {!showMdash && <span className={style.info}>{packageType}</span>}
    </LabeledRow>
  );
};

Package.propTypes = {
  packageType: PropTypes.string,
  showMdash: PropTypes.bool,
};

export default Package;
